export default __webpack_public_path__ + "static/media/clarinet_two.0401691b.mp3";